"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ImageUpload = require("./ImageUpload");
Object.keys(_ImageUpload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ImageUpload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ImageUpload[key];
    }
  });
});
